
/* global modForm modUtils */
export function getProjExUrl() {
	const urlParams = { ...modForm.opts.getVars };
	let url;

	if (window.projectId) {
		url = modUtils.getModernizeDomain() + '/my/project-' + window.projectId;

		if (Object.keys(urlParams).length && urlParams.hrcreferrer) {
			urlParams.referrer = urlParams.hrcreferrer;
		} else {
			urlParams.referrer = window.location.protocol + '//' + window.location.host + window.location.pathname;
		}

		if (Object.keys(urlParams).length) {
			url += '?' + new URLSearchParams(urlParams).toString();
		}
	} else {
		url = 'https://modernize.com/quote/unmatched';
	}

	return url;
}
